import {
    getAttendeeTimezone,
    getEventDatesFormat,
    getFormattedEventDate as formatEventDate,
    shouldShowDateInAttendeeTimezone,
    TimezoneLocale,
} from '@eventbrite/event-date-time';
import { CheckoutState } from '../../state';
import { EventNamespace } from '../../state/event';
import { getIsEventOnline } from './pureSelectors';

/**
 * Selector that can be used to retrieve the full event date range string to display
 */
export const getFormattedEventDate = (state: CheckoutState) => {
    const userLocale = state.app.locale;
    const useTimezoneFrom = shouldShowDateInAttendeeTimezone({
        isOnlineEvent: getIsEventOnline(state),
        userTimezone: getAttendeeTimezone(),
    })
        ? TimezoneLocale.Attendee // Attendee for onLine events
        : TimezoneLocale.Creator; // Creator for onsite events

    const event = state.event as EventNamespace;

    return formatEventDate({
        event,
        locale: userLocale,
        datesFormat: getEventDatesFormat({
            event,
            locale: userLocale,
            useTimezoneFrom,
        }),
        useTimezoneFrom,
    });
};
